import type { z } from 'zod'
import { idSchemaV2, isId } from '../ids'

export const ConversationFlagMatchIdSchema = idSchemaV2('ConvoFlagMatch')
export type ConversationFlagMatchId = z.infer<typeof ConversationFlagMatchIdSchema>
export const isConversationFlagMatchId = isId(ConversationFlagMatchIdSchema)
